import classNames from "classnames";

import { NavigationLogo } from "./Navigation/NavigationLogo";
import { NavigationTab } from "./Navigation/NavigationTab";
import { NavigationInfo } from "./Navigation/NavigationInfo";

const Navigation = ({ expanded, setExpanded }: any) => {
    return (
        <nav
            aria-expanded={expanded ? "true" : "false"}
            className={classNames(
                "group bg-navigation flex flex-col justify-between h-screen rounded-r-[48px] shadow-lg sticky left-0 top-0 w-[70px]",
                "aria-expanded:w-[280px]",
            )}
        >
            {/* 100px */}
            <NavigationLogo expanded={expanded} setExpanded={setExpanded} />

            {expanded && <NavigationTab />}

            {/* 240px / 120px */}
            <NavigationInfo expanded={expanded} />
        </nav>
    );
};

export default Navigation;
